import { Users, UserCheck, Briefcase, Layers } from "lucide-react";

const StaffStats = ({ staffs = [] }) => {
  const stats = [
    { label: "Total Staff", value: staffs.length, icon: <Users size={22} /> },
    {
      label: "Active Staff",
      value: staffs.filter(s => s.Status === "Active").length,
      icon: <UserCheck size={22} />
    },
    {
      label: "Departments",
      value: new Set(staffs.map(s => s.Department)).size,
      icon: <Briefcase size={22} />
    },
    {
      label: "Designations",
      value: new Set(staffs.map(s => s.Designation)).size,
      icon: <Layers size={22} />
    }
  ];

  return (
    <div className="student-stats">
      {stats.map((s, i) => (
        <div key={i} className="stat-card">
          <div className="stat-icon">{s.icon}</div>
          <div className="stat-info">
            <span className="stat-label">{s.label}</span>
            <strong className="stat-value">{s.value}</strong>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StaffStats;
